(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4718],{

/***/ 2320:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/pd/digital-gift-card/[id]",
      function () {
        return __webpack_require__(45372);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./ui/components/ManagedHeading.tsx
var ManagedHeading = __webpack_require__(93512);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
// EXTERNAL MODULE: ./ui/components/Breadcrumb.tsx + 1 modules
var Breadcrumb = __webpack_require__(37404);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useValidation.ts + 1 modules
var useValidation = __webpack_require__(70750);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./ui/components/MiniCart/index.ts + 5 modules
var MiniCart = __webpack_require__(65656);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ./gql/fragments/cart.ts
var cart = __webpack_require__(32317);
;// CONCATENATED MODULE: ./gql/mutations/cart.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddItemsToCart($input: AddItemsToCartInput!) {\n    addItemsToCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateItemInCart($input: UpdateItemInCartInput!) {\n    updateItemInCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveItemFromCart($input: RemoveItemFromCartInput!) {\n    removeItemFromCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddGiftCardToCart($input: AddGiftCardToCartInput!) {\n    addGiftCardToCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveGiftCardFromCart($input: RemoveGiftCardFromCartInput!) {\n    removeGiftCardFromCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddGiftCard($input: AddGiftCardInput!) {\n    addGiftCard(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveGiftCard($input: RemoveGiftCardInput!) {\n    removeGiftCard(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateShippingAddress($input: UpdateShippingAddressInput!) {\n    updateShippingAddress(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateShipmentMethod($input: UpdateShipmentMethodInput!) {\n    updateShipmentMethod(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateBillingAddress($input: UpdateBillingAddressInput!) {\n    updateBillingAddress(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveCouponFromCart($input: RemoveCouponFromCartInput!) {\n    removeCouponFromCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddCouponToCart($input: AddCouponToCartInput!) {\n    addCouponToCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddPaymentPromotion($input: AddPaymentPromotionInput!) {\n    addPaymentPromotion(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddAmbassadorCardToCart($input: AddAmbassadorCardToCartInput!) {\n    addAmbassadorCardToCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveAmbassadorCardFromCart(\n    $input: RemoveAmbassadorCardFromCartInput!\n  ) {\n    removeAmbassadorCardFromCart(input: $input) {\n      ...cartFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddStoreCredits($input: AddStoreCreditsInput!) {\n    addStoreCredits(input: $input) {\n      cart {\n        ...cartFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveStoreCredits($input: RemoveStoreCreditsInput!) {\n    removeStoreCredits(input: $input) {\n      cart {\n        ...cartFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var ADD_ITEMS_TO_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject(), cart/* CART_FRAGMENT */.Gd);
var UPDATE_CART_ITEM_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject1(), cart/* CART_FRAGMENT */.Gd);
var REMOVE_ITEM_FROM_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject2(), cart/* CART_FRAGMENT */.Gd);
var ADD_GIFTCARD_TO_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject3(), cart/* CART_FRAGMENT */.Gd);
var REMOVE_GIFT_CARD_FROM_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject4(), cart/* CART_FRAGMENT */.Gd);
var ADD_GIFT_CARD_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject5(), cart/* CART_FRAGMENT */.Gd);
var REMOVE_GIFT_CARD_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject6(), cart/* CART_FRAGMENT */.Gd);
var UPDATE_SHIPPING_ADDRESS_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject7(), cart/* CART_FRAGMENT */.Gd);
var UPDATE_SHIPMENT_METHOD = (0,urql_core/* gql */.Ps)(_templateObject8(), cart/* CART_FRAGMENT */.Gd);
var UPDATE_BILLING_ADDRESS_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject9(), cart/* CART_FRAGMENT */.Gd);
var REMOVE_COUPON_FROM_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject10(), cart/* CART_FRAGMENT */.Gd);
var ADD_COUPON_TO_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject11(), cart/* CART_FRAGMENT */.Gd);
var ADD_PAYMENT_PROMOTION_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject12(), cart/* CART_FRAGMENT */.Gd);
var ADD_AMBASSADOR_CARD_TO_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject13(), cart/* CART_FRAGMENT */.Gd);
var REMOVE_AMBASSADOR_CARD_FROM_CART_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject14(), cart/* CART_FRAGMENT */.Gd);
var ADD_STORE_CREDITS_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject15(), cart/* CART_FRAGMENT */.Gd);
var REMOVE_STORE_CREDITS_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject16(), cart/* CART_FRAGMENT */.Gd);

// EXTERNAL MODULE: ./hooks/useSimpleCart.tsx
var useSimpleCart = __webpack_require__(85914);
;// CONCATENATED MODULE: ./pages/[country]/[language]/pd/digital-gift-card/[id]/index.tsx
























var VirtualGiftCard = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 1), validate = ref9[0];
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGiftCardQuery */.ksR)(), 1), query = ref10[0];
    var giftCard = (ref = query.data) === null || ref === void 0 ? void 0 : ref.giftCard;
    var path = [
        {
            label: "home",
            url: ""
        },
        {
            label: t("giftCard"),
            url: ""
        }, 
    ];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(ADD_GIFTCARD_TO_CART_MUTATION), 2), addGiftCardResult = ref11[0], addGiftCard = ref11[1];
    var ref12 = (0,useMiniCart/* useMiniCart */.lm)(), isMiniCartVisible = ref12.isMiniCartVisible, openMiniCart = ref12.openMiniCart;
    var cart = (0,useSimpleCart/* useSimpleCart */.r)().cart;
    var ref13 = (0,index_esm/* useForm */.cI)({
        defaultValues: (0,_object_spread/* default */.Z)({}, (giftCard === null || giftCard === void 0 ? void 0 : giftCard.defaultValue) && {
            value: giftCard.defaultValue
        }),
        mode: "onChange"
    }), register = ref13.register, handleSubmit = ref13.handleSubmit, watch = ref13.watch, errors = ref13.errors, formState = ref13.formState, reset = ref13.reset;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, customValue, orderData, addGiftCardResult, _tmp, productsInCart, giftCardsInCart, latestGiftCard;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customValue = data.customValue, orderData = (0,_object_without_properties/* default */.Z)(data, [
                            "customValue"
                        ]);
                        if (orderData.value === "custom") orderData.value = customValue;
                        _tmp = {};
                        return [
                            4,
                            addGiftCard((_tmp.input = {
                                amount: Number(orderData.value),
                                recipientName: orderData.recipientName,
                                recipientEmail: orderData.recipientEmail,
                                senderName: orderData.yourName,
                                message: orderData.giftMessage,
                                basketId: cart === null || cart === void 0 ? void 0 : cart.id
                            }, _tmp))
                        ];
                    case 1:
                        addGiftCardResult = _state.sent();
                        productsInCart = (ref = addGiftCardResult.data) === null || ref === void 0 ? void 0 : ref.addGiftCardToCart.products;
                        giftCardsInCart = (productsInCart === null || productsInCart === void 0 ? void 0 : productsInCart.filter(function(product) {
                            return product.__typename === "GiftCardCartItem";
                        })) || [];
                        if ((giftCardsInCart === null || giftCardsInCart === void 0 ? void 0 : giftCardsInCart.length) > 0) {
                            latestGiftCard = giftCardsInCart[giftCardsInCart.length - 1];
                            openMiniCart(latestGiftCard);
                        }
                        reset();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var showCustomValueField = watch("value") === "custom";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
        query: query,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: t("pageTitleReduced", {
                    title: t("digitalGiftCard")
                })
            }),
            !query.fetching && giftCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* Breadcrumb */.a, {
                        path: path
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Container */.W20, {
                        size: "lg",
                        className: " grid grid-cols-1 md:grid-cols-12 gap-10 items-start pb-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-6 xl:pr-6 h-full relative",
                                style: {
                                    paddingTop: "85%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: giftCard.image,
                                    alt: t("giftCard"),
                                    width: "1000",
                                    height: "1000",
                                    className: "mb-4 absolute inset-0 w-full h-full object-cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                gap: "xl",
                                className: "md:col-span-6 lg:pr-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                                        size: "xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                                            tag: "h1",
                                            children: t("digitalGiftCard")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            onSubmit: handleSubmit(onSubmit),
                                            noValidate: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,style.tw)("grid gap-3", showCustomValueField ? "grid-cols-2" : "grid-cols-1"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputSelect */.JDu, {
                                                                    id: "select-gift-card-value",
                                                                    name: "value",
                                                                    placeholder: t("selectValue"),
                                                                    label: t("selectValue"),
                                                                    options: (0,_to_consumable_array/* default */.Z)(giftCard.valueOptions.map(function(value) {
                                                                        return {
                                                                            value: "".concat(value),
                                                                            label: "".concat(currency.symbol).concat(value, ".00")
                                                                        };
                                                                    })).concat([
                                                                        {
                                                                            value: "custom",
                                                                            label: t("custom")
                                                                        }, 
                                                                    ]),
                                                                    defaultValue: watch("value"),
                                                                    errorText: (ref1 = errors.value) === null || ref1 === void 0 ? void 0 : ref1.message,
                                                                    required: true,
                                                                    ref: register({
                                                                        required: t("requiredField"),
                                                                        validate: function(value) {
                                                                            if (value === "placeholder") return t("requiredField");
                                                                            return undefined;
                                                                        }
                                                                    })
                                                                }),
                                                                showCustomValueField && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                                                    id: "customValue",
                                                                    name: "customValue",
                                                                    label: t("setValue"),
                                                                    placeholder: t("setValue"),
                                                                    type: "number",
                                                                    step: 10,
                                                                    min: 10,
                                                                    max: 500,
                                                                    required: true,
                                                                    ref: register({
                                                                        required: t("requiredField"),
                                                                        pattern: {
                                                                            value: /^\d+\.?\d*$/,
                                                                            message: t("giftCardValueFormat")
                                                                        },
                                                                        validate: function(value) {
                                                                            var customValue = Number(value);
                                                                            if (customValue < 10 || customValue > 500) return t("giftCardValueRange");
                                                                            if (customValue % 10) return t("giftCardValueMultiple");
                                                                        }
                                                                    }),
                                                                    errorText: errors === null || errors === void 0 ? void 0 : (ref2 = errors.customValue) === null || ref2 === void 0 ? void 0 : ref2.message,
                                                                    crossOrigin: undefined
                                                                })
                                                            ]
                                                        }),
                                                        (errors === null || errors === void 0 ? void 0 : (ref3 = errors.customValue) === null || ref3 === void 0 ? void 0 : ref3.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            id: "customValue_error",
                                                            className: "text-xs text-puma-red self-start rounded-b leading-tight mt-1",
                                                            children: errors.customValue.message
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                                    id: "recipientName",
                                                    name: "recipientName",
                                                    placeholder: t("recipientName"),
                                                    label: t("recipientName"),
                                                    required: true,
                                                    ref: register({
                                                        required: t("requiredField"),
                                                        validate: validate.safeInput,
                                                        maxLength: {
                                                            value: 100,
                                                            message: t("genericFieldMaxLength", {
                                                                length: 100
                                                            })
                                                        }
                                                    }),
                                                    errorText: (ref4 = errors.recipientName) === null || ref4 === void 0 ? void 0 : ref4.message,
                                                    crossOrigin: undefined
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                                    id: "yourName",
                                                    name: "yourName",
                                                    placeholder: t("yourName"),
                                                    label: t("yourName"),
                                                    required: true,
                                                    ref: register({
                                                        required: t("requiredField"),
                                                        validate: validate.safeInput,
                                                        maxLength: {
                                                            value: 100,
                                                            message: t("genericFieldMaxLength", {
                                                                length: 100
                                                            })
                                                        }
                                                    }),
                                                    errorText: (ref5 = errors.yourName) === null || ref5 === void 0 ? void 0 : ref5.message,
                                                    crossOrigin: undefined
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                                    id: "recipientEmail",
                                                    name: "recipientEmail",
                                                    placeholder: t("recipientEmail"),
                                                    label: t("recipientEmail"),
                                                    type: "email",
                                                    required: true,
                                                    ref: register({
                                                        required: t("requiredField"),
                                                        validate: validate.email,
                                                        maxLength: {
                                                            value: 50,
                                                            message: t("genericFieldMaxLength", {
                                                                length: 50
                                                            })
                                                        }
                                                    }),
                                                    errorText: (ref6 = errors.recipientEmail) === null || ref6 === void 0 ? void 0 : ref6.message,
                                                    crossOrigin: undefined
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                                    id: "confirmEmail",
                                                    name: "confirmEmail",
                                                    placeholder: t("confirmEmail"),
                                                    label: t("confirmEmail"),
                                                    type: "email",
                                                    required: true,
                                                    ref: register({
                                                        required: t("requiredField"),
                                                        validate: function(value) {
                                                            return value !== watch("recipientEmail") ? t("emailsDontMatch") : undefined;
                                                        },
                                                        maxLength: {
                                                            value: 50,
                                                            message: t("genericFieldMaxLength", {
                                                                length: 50
                                                            })
                                                        }
                                                    }),
                                                    errorText: (ref7 = errors.confirmEmail) === null || ref7 === void 0 ? void 0 : ref7.message,
                                                    crossOrigin: undefined
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputTextArea */.zg5, {
                                                    id: "giftMessage",
                                                    name: "giftMessage",
                                                    label: t("message"),
                                                    placeholder: t("message"),
                                                    size: "base",
                                                    ref: register({
                                                        validate: validate.safeInput,
                                                        maxLength: {
                                                            value: 300,
                                                            message: t("genericFieldMaxLength", {
                                                                length: 300
                                                            })
                                                        }
                                                    }),
                                                    rows: 6,
                                                    maxLength: 300,
                                                    errorText: (ref8 = errors.giftMessage) === null || ref8 === void 0 ? void 0 : ref8.message
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                    loading: addGiftCardResult.fetching,
                                                    dataTestId: "gift-card-add-to-cart",
                                                    label: t("addToCart"),
                                                    type: "submit",
                                                    disabled: !formState.isValid || addGiftCardResult.fetching,
                                                    icon: "cart"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isMiniCartVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* MiniCart */.pp, {})
        ]
    });
};
/* harmony default export */ var _id_ = (VirtualGiftCard);


/***/ }),

/***/ 37404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/string-strip-html/dist/string-strip-html.cjs.js
var string_strip_html_cjs = __webpack_require__(50967);
// EXTERNAL MODULE: ./utils/removeHyphens.ts
var removeHyphens = __webpack_require__(47802);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(59308);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./utils/isContentOnline.ts
var isContentOnline = __webpack_require__(89996);
// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
;// CONCATENATED MODULE: ./hooks/useBreadcrumbUrlRedirects.ts








var isRedirectActive = function(redirect) {
    var availableFrom = redirect.availableFrom, availableTo = redirect.availableTo;
    var isAvailable = (0,isContentOnline/* isContentOnline */.e)({
        onlineFrom: availableFrom,
        onlineTo: availableTo
    }, {});
    if (!isAvailable || !redirect.url) return false;
    return true;
};
var useBreadcrumbUrlRedirects = function(links) {
    var client = (0,urql_es/* useClient */.m8)();
    var ref = (0,react.useState)(undefined), redirections = ref[0], setRedirections = ref[1];
    var fetchRedirections = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var breadcrumbPromises, results, updatedPaths, _tmp, _tmp1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    breadcrumbPromises = (0,breadcrumbRedirects/* fetchBreadcrumbRedirectPromises */.VD)(client, links);
                    return [
                        4,
                        Promise.all(breadcrumbPromises)
                    ];
                case 1:
                    results = _state.sent();
                    updatedPaths = results.map(function(param, idx) {
                        var data = param.data;
                        return data && isRedirectActive(data.urlRedirectV2) ? {
                            label: links[idx + 1].label,
                            url: data.urlRedirectV2.url
                        } : (0,_object_spread/* default */.Z)({}, links[idx + 1]);
                    });
                    _tmp = {};
                    _tmp1 = {};
                    if (updatedPaths.length > 0) {
                        setRedirections([
                            (0,_object_spread/* default */.Z)(_tmp, links[0])
                        ].concat((0,_to_consumable_array/* default */.Z)(updatedPaths), [
                            (0,_object_spread/* default */.Z)(_tmp1, links[links.length - 1])
                        ]));
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        client,
        links
    ]);
    return {
        fetchRedirections: fetchRedirections,
        redirections: redirections
    };
};

// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
;// CONCATENATED MODULE: ./ui/components/Breadcrumb.tsx
















var Breadcrumb = function(param) {
    var path = param.path, isPdpFromPlp = param.isPdpFromPlp;
    var router = (0,next_router.useRouter)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), host = ref.host, locale = ref.locale, absoluteLinkBreadcrumb = ref.absoluteLinkBreadcrumb, isPNARegion = ref.staticFeatures.isPNARegion;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var protocol = constants/* isServer */.sk ? "https:" : window.location.protocol;
    var baseUrlLink = "".concat(protocol, "//").concat(host).concat((0,utils_locale/* getUrlFromLocale */.bH)(locale));
    var baseUrl = absoluteLinkBreadcrumb ? baseUrlLink : "";
    var pdpUrlRegex = /^[a-z]{2}\/[a-z]{2}\/pd\/.*\/\\d{6,}/;
    var isPdp = pdpUrlRegex.test(router.pathname);
    // Build links array
    var links = (0,react.useMemo)(function() {
        return path.filter(function(pathElement) {
            return pathElement.url !== "/puma";
        }).map(function(param) {
            var label = param.label, url = param.url;
            var displayLabel = isPdp ? (0,removeHyphens/* removeHyphens */.V)(label) : label === "home" ? t("home") : label;
            var fullUrl = "".concat(baseUrl, "/").concat(encodeURI(url.length && url[0] === "/" ? url.slice(1) : url));
            return {
                label: displayLabel,
                url: fullUrl
            };
        });
    }, [
        path,
        isPdp,
        t,
        host,
        locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var ref1 = useBreadcrumbUrlRedirects(links), redirections = ref1.redirections, fetchRedirections = ref1.fetchRedirections;
    (0,react.useEffect)(function() {
        if (isPNARegion && links.length > 0) {
            fetchRedirections();
        }
    }, [
        isPNARegion,
        links.length,
        fetchRedirections
    ]);
    var prevToLastLink = links[links.length - 2] || links[0];
    var showMobilePdpBreadcrumb = !(0,media/* getIsDesktop */.w)() && isPdpFromPlp;
    var removeTrailingSlash = function(url) {
        return url.endsWith("/") ? url.slice(0, -1) : url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMobilePdpBreadcrumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "flex items-center font-bold",
                onClick: function() {
                    return router.back();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-0.5 mr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            size: "sm",
                            name: "chevron-left"
                        })
                    }),
                    prevToLastLink.label
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Breadcrumb */.aGc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* FITANALYTICS_IS_LOADED_INDICATOR */.S7), {
                path: redirections !== null && redirections !== void 0 ? redirections : links,
                className: "-ml-1.5"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    itemListElement: links.map(function(item, index) {
                        return {
                            "@type": "ListItem",
                            position: index + 1,
                            name: (0,capitalize/* capitalize */.k)((0,string_strip_html_cjs.stripHtml)(item.label).result),
                            item: item.url.startsWith("http") ? item.url : removeTrailingSlash("".concat(baseUrlLink).concat(item.url)),
                            logo: "https://".concat(host, "/assets/logo-puma-black.png")
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* binding */ createCategoryPageBreadcrumbLinks; },
  "A2": function() { return /* binding */ createProductBreadcrumbLinks; },
  "VD": function() { return /* binding */ fetchBreadcrumbRedirectPromises; }
});

// UNUSED EXPORTS: getLinksToCheck

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/queries/urlRedirect.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UrlRedirect($path: String!) {\n    urlRedirectV2(path: $path) {\n      availableFrom\n      availableTo\n      redirectType\n      url\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var URL_REDIRECT_QUERY = (0,urql_core/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
;// CONCATENATED MODULE: ./utils/breadcrumbRedirects.ts



/**
 * Creates an array of breadcrumb links from a category
 * @param currentCategory - The category data
 * @returns Array of breadcrumb links
 */ var createCategoryPageBreadcrumbLinks = function(currentCategory) {
    var categoryPath = (0,constructCategoryPath/* constructCategoryPath */.h)(currentCategory);
    return [
        {
            label: "home",
            url: ""
        }
    ].concat((0,_to_consumable_array/* default */.Z)(categoryPath));
};
/**
 * Creates breadcrumb links specifically for product detail pages
 * @param params - Object containing necessary data for product breadcrumbs
 * @returns Array of raw breadcrumb links ready for display
 */ var createProductBreadcrumbLinks = function(param) {
    var categoryById = param.categoryById, productName = param.productName, productLink = param.productLink, _isCustomizing = param.isCustomizing, isCustomizing = _isCustomizing === void 0 ? false : _isCustomizing, _customizeUrl = param.customizeUrl, customizeUrl = _customizeUrl === void 0 ? "" : _customizeUrl, _customizeLabel = param.customizeLabel, customizeLabel = _customizeLabel === void 0 ? "customize" : _customizeLabel, _isPersonalizing = param.isPersonalizing, isPersonalizing = _isPersonalizing === void 0 ? false : _isPersonalizing, _personalizeLabel = param.personalizeLabel, personalizeLabel = _personalizeLabel === void 0 ? "personaliseBreadcrumb" : _personalizeLabel;
    var categoryLinks = createCategoryPageBreadcrumbLinks(categoryById);
    var links = (0,_to_consumable_array/* default */.Z)(categoryLinks);
    if (productName && productLink) {
        links.push({
            label: productName,
            url: productLink,
            isAbsoluteUrl: true
        });
    }
    if (isCustomizing && customizeUrl) {
        links.push({
            label: customizeLabel,
            url: customizeUrl
        });
    }
    if (isPersonalizing) {
        links.push({
            label: personalizeLabel,
            url: ""
        });
    }
    return links;
};
/**
 * Gets the links that need to be checked for redirects
 * @param links - The full breadcrumb links array
 * @returns Array of links to check for redirects
 */ var getLinksToCheck = function(links) {
    // Skip first and last elements as per useBreadcrumbUrlRedirects implementation
    return links.slice(1, -1);
};
/**
 * Fetches URL redirect queries for breadcrumb links
 * @param client - The URQL client
 * @param links - The links to check for redirects
 * @returns Promise with the results of the redirect queries
 */ var fetchBreadcrumbRedirectPromises = function(client, links) {
    var linksToCheck = getLinksToCheck(links);
    // Create URL redirect queries for each breadcrumb link
    return linksToCheck.map(function(param) {
        var url = param.url;
        return client.query(URL_REDIRECT_QUERY, {
            path: url.startsWith("/") ? url.slice(1) : url
        });
    });
};


/***/ }),

/***/ 13583:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9372,1489,9294,2042,6740,769,9690,1061,5656,9774,2888,179], function() { return __webpack_exec__(2320); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);